import { leaveFormType } from '../Pages/Frontend/Interface/EmployeeManager/LeaveApplication/LeaveApplication'
import axios from 'axios'

export const leaveService = {
  index: async () => {
    return await axios.get('admin/leave-applications')
  },

  getUserLeave: async (pageNumber: number) => {
    return await axios.get(`/leave-applications?pageNumber=${pageNumber}`)
  },

  getLeaveRemainingDays: async () => {
    return await axios.get('/leave-applications/remaining-days')
  },

  create: async (data: leaveFormType) => {
    console.log('leaveForm', data)
    return await axios.post('/leave-applications', data)
  },

  getAdminLeave: async (
    pageNumber: number,
    sortOrder?: string,
    status?: string,
    hrApprovalStatus?: string,
    name?: string,
  ) => {
    return await axios.get('/admin/leave-applications', {
      params: {
        pageNumber,
        sortOrder,
        status,
        hrApprovalStatus,
        name,
      },
    })
  },
  
  getLineManagerLeave: async (pageNumber: number, userId: string | undefined) => {
    return await axios.get(
      `/admin/leave-applications?pageNumber=${pageNumber}&lineManagerUserId=${userId}`,
    )
  },
  getTeamLeave: async (pageNumber: number, status: string, sortOrder: string) => {
    return await axios.get(
      `/leave-applications/team?pageNumber=${pageNumber}&status=${status}&sortOrder=${sortOrder}`,
    )
  },
  leaveAction: async (leaveId: string, action: string, isHr?: boolean) => {
    if (isHr) {
      return await axios.put(`/admin/leave-applications/${leaveId}/hr-approval`, {
        action: 'APPROVED',
      })
    }
    return await axios.put(`/admin/leave-applications/${leaveId}/${action}`)
  },
}
